import { useTokenChecker } from '@/auth/useTokenChecker';
import { registerAuthenticatedFcmToken } from '@/services/fcmService';
import { useEffect, useState } from 'react';
import { Outlet } from 'react-router';
import { ToastContainer } from 'react-toastify';
import Navbar from './Navbar';
import SideBar from './Sidebar/SideBar';

function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  useTokenChecker();

  // Register FCM token once per authenticated session (web pseudo-token)
  useEffect(() => {
    registerAuthenticatedFcmToken();
  }, []);

  return (
    <div className="flex h-screen bg-background">
      <ToastContainer />

      {/* Mobile overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-40 bg-black/40 backdrop-blur-sm lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar - hidden on mobile unless toggled */}
      <div
        className={`fixed inset-y-0 left-0 z-50 lg:relative lg:z-auto sidebar-transition ${
          sidebarOpen ? 'translate-x-0 opacity-100' : '-translate-x-full opacity-0 lg:translate-x-0 lg:opacity-100'
        }`}
      >
        <SideBar onClose={() => setSidebarOpen(false)} />
      </div>

      <section className="flex flex-1 flex-col overflow-hidden">
        <Navbar onMenuToggle={() => setSidebarOpen(!sidebarOpen)} />
        <main className="flex-1 overflow-auto p-4 sm:p-6">
          <Outlet />
        </main>
      </section>
    </div>
  );
}
export default Layout;
